module.exports = __webpack_public_path__ + "static/media/na.ed7cd194.svg";